import { connect } from 'react-redux'
import SignupSuccess from '../../components/authentication/SignupSuccess'
import { resendInviteEmail } from '../../state/actions/auth/index'
import { IUserRegisterEmailFormData } from '../../types/index'

export function mapDispatchToProps(dispatch: any) {
  return {
    resendInviteEmail: (data: IUserRegisterEmailFormData) => dispatch(resendInviteEmail(data))
  }
}

export default connect(
  null,
  mapDispatchToProps
)(SignupSuccess)



// WEBPACK FOOTER //
// ./src/containers/auth/SignupSuccess.ts